import React, { useEffect, useState } from 'react'
import UserForm from './UserForm';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllUsers } from '../../store/authSlice';
import UserTile from './UserTile';

function User() {

  const { user, userList } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null); // Les données de la ligne sélectionnée
  const [isEditing, setIsEditing] = useState(false); // Détermine si la modale est en mode édition


  useEffect(() => {
    //dispatch(fetchAllUsers());
  }, [dispatch]);
  //dispatch(fetchAllUsers());

  function handleAllUsers() {
    dispatch(fetchAllUsers());
  }

  // Ouvre la modale avec les données d'une ligne
  const openModal = (row) => {
    setModalData(row);
    setIsEditing(false); // Par défaut, mode lecture
    setIsModalOpen(true);
  };

  // Passe au mode édition
  const enableEditMode = () => {
    setIsEditing(true);
  };

  // Ferme la modale
  const closeModal = () => {
    setIsModalOpen(false);
    setModalData(null);
  };

  // Sauvegarde les modifications
  const saveChanges = () => {
    setIsEditing(false); // Revenir en mode lecture
  };


  return (
    <>
      <div className="bg-gray-100">

        <div className="">
          <nav className="flex justify-between items-center bg-gray-100 p-2">
            <h1 className="font-semibold text-gray-700 text-lg">Lis des utilisateurs</h1>
            <button onClick={handleAllUsers}>Get Users</button>
          </nav>
        </div>

        <div className="bg-white border rounded-b">

          {
            userList && userList.length > 0 ? (
              userList.map((userItem) => (
                <UserTile
                  key={userItem.id}
                  userItem={userItem}
                />
              ))
            ) : (
              <p>Aucun utilisateur disponible.</p>
            )
          }





          <div className="px-3 border-b">
            <form action="" className="flex">
              <input className="flex-1 p-3" type="text" placeholder="Recherche de produit" />
              <button type="submit" className="p-3">
                <i className="fa-search fad"></i>
              </button>
            </form>
          </div>

          <div className="flex flex-row flex-1">

            <table className="w-full text-left table-auto">
              <thead>
                <tr>
                  <th className="px-4 py-2 border-r">Matricule </th>
                  <th className="px-4 py-2 border-r">Code </th>
                  <th className="px-4 py-2 border-r">Nom </th>
                  <th className="px-4 py-2">Salaire</th>
                  <th className="px-4 py-2">Satuts</th>
                </tr>
              </thead>
              <tbody className="text-gray-600 text-sm">

                <tr className='hover:bg-green-400 hover:text-white hover:cursor-pointer'
                  onClick={() => openModal({ id: 1, name: "John Doe", email: "john@example.com" })}>
                  <td className="px-4 py-1 border border-l-0">Lightning to USB-C Adapter Lightning.</td>
                  <td className="px-4 py-1 border border-l-0">$<span className="num-2"></span></td>
                  <td className="px-4 py-1 border border-r-0 border-l-0"><span className="num-2"></span> minutes ago</td>
                </tr>
                <tr className='hover:bg-green-400 hover:text-white hover:cursor-pointer'>
                  <td className="px-4 py-1 border border-l-0">Apple iPhone 8.</td>
                  <td className="px-4 py-1 border border-l-0">$<span className="num-2"></span></td>
                  <td className="px-4 py-1 border border-r-0 border-l-0"><span className="num-2"></span> minutes ago</td>
                </tr>
                <tr className='hover:bg-green-400 hover:text-white hover:cursor-pointer'>
                  <td className="px-4 py-1 border border-l-0">Apple MacBook Pro.</td>
                  <td className="px-4 py-1 border border-l-0">$<span className="num-2"></span></td>
                  <td className="px-4 py-1 border border-r-0 border-l-0"><span className="num-2"></span> minutes ago</td>
                </tr>
                <tr className='hover:bg-green-400 hover:text-white hover:cursor-pointer'>
                  <td className="px-4 py-1 border border-l-0">Samsung Galaxy S9.</td>
                  <td className="px-4 py-1 border border-l-0">$<span className="num-2"></span></td>
                  <td className="px-4 py-1 border border-r-0 border-l-0"><span className="num-2"></span> minutes ago</td>
                </tr>
                <tr className='hover:bg-green-400 hover:text-white hover:cursor-pointer'>
                  <td className="px-4 py-1 border border-l-0">Samsung Galaxy S8 256GB.</td>
                  <td className="px-4 py-1 border border-l-0">$<span className="num-2"></span></td>
                  <td className="px-4 py-1 border border-r-0 border-l-0"><span className="num-2"></span> minutes ago</td>
                </tr>
                <tr className='hover:bg-green-400 hover:text-white hover:cursor-pointer'>
                  <td className="px-4 py-1 border border-b-0 border-l-0">apple watch.</td>
                  <td className="px-4 py-1 border border-b-0 border-l-0">$<span className="num-2"></span></td>
                  <td className="px-4 py-1 border border-r-0 border-b-0 border-l-0"><span className="num-2"></span> minutes ago</td>
                </tr>

              </tbody>
            </table>

          </div>

          {/* footer */}
          <div className="px-3 border">
            <div className="flex justify-between items-center py-1">
              <button className="bg-gray-200 hover:bg-gray-300 px-4 py-1 rounded">Previous</button>
              <span className="text-gray-700">Page 1 of 5</span>
              <button className="bg-gray-200 hover:bg-gray-300 px-4 py-1 rounded">Next</button>
            </div>
          </div>


          {/* Modale */}
          {isModalOpen && (
            <UserForm
              isEditing={isEditing}
              modalData={modalData}
              setModalData={setModalData}
              enableEditMode={enableEditMode}
              saveChanges={saveChanges}
              closeModal={closeModal} />
          )}
        </div>

      </div>
    </>
  )
}

export default User